import { LambdaWebAutoDeploymentMode, LambdaWebRevisionWeight } from '@localstack/types';

export const getWebEndpointRoutingError = (
  mode: LambdaWebAutoDeploymentMode | undefined,
  weights: LambdaWebRevisionWeight[],
): string | undefined => {
  if (mode !== 'Disabled') return undefined;
  // MagicForm does not validate constraints across list rows.
  if (weights.length < 1 || weights.length > 2) return 'Select one or two revisions.';
  if (weights.some(({ revisionId }) => !revisionId)) return 'Select a revision for each traffic weight.';
  if (new Set(weights.map(({ revisionId }) => revisionId)).size !== weights.length) {
    return 'Select different revisions to split traffic.';
  }
  if (weights.some(({ weight }) => weight === undefined || !Number.isInteger(weight) || weight < 1 || weight > 100)) {
    return 'Each traffic weight must be a whole number between 1 and 100.';
  }
  if (weights.reduce((total, { weight }) => total + (weight ?? 0), 0) !== 100) {
    return 'Traffic weights must total 100%.';
  }
  return undefined;
};
